import React from 'react'
import moment from 'moment'

const NewsItemDate = ({ postItem, postItemHome }) => {
  // Validation des props et gestion des cas limites
  if (!postItem || !postItem._source || !postItem._source.post_date) {
    return null
  }

  // Fonction pour valider et formater la date
  const getFormattedDate = () => {
    try {
      const date = moment(postItem._source.post_date)
      
      // Vérifier que la date est valide
      if (!date.isValid()) {
        return null
      }
      
      // Formater la date en français
      return date.locale('fr').format('DD MMMM YYYY')
    } catch (error) {
      console.warn('Erreur de formatage de date:', error)
      return null
    }
  }

  const formattedDate = getFormattedDate()
  
  // Si la date n'est pas valide, ne pas rendre le composant
  if (!formattedDate) {
    return null
  }

  // Classes CSS conditionnelles
  const dateClasses = [
    'news-list-item-date',
    postItemHome ? 'news-list-home-item-date' : ''
  ].filter(Boolean).join(' ')

  return (
    <p 
      className={dateClasses}
      role="text"
      aria-label={`Date de publication: ${formattedDate}`}
    >
      Publié le {formattedDate}
    </p>
  )
}

export default NewsItemDate